import { GenericTabs } from 'components/Tabs';
import { useState } from 'react';
import TemplateMapper from 'templates/TemplateMapper';

import type { Tab } from 'server/repository/hygraph/generated/graphqlTypes';
import type { AvailableTemplates, ISharedTemplateProps } from 'templates/TemplateMapper/types';

interface ITabsContainer extends ISharedTemplateProps {
  templateProps: Tab;
}

export const TabsContainer = ({ templateProps, copy }: ITabsContainer) => {
  const [selectedTab, setSelectedTab] = useState(0);
  const selectedItem = templateProps.tabs?.[selectedTab];
  return (
    <GenericTabs
      setSelectedTab={setSelectedTab}
      tabs={templateProps.tabs}
      cmsTabTitle={templateProps.cmsTabTitle}
    >
      <TemplateMapper components={selectedItem?.components as AvailableTemplates[]} copy={copy} />
    </GenericTabs>
  );
};
